export enum CollectionCarouselPage {
  COLLECTION = "COLLECTION",
  BRAND = "BRAND",
  PDP = "PDP",
  SEE_ALL = "SEE_ALL",
}

export enum CollectionImpression {
  COLLECTION_CAROUSEL = "COLLECTION_CAROUSEL",
  BRAND_CAROUSEL = "BRAND_CAROUSEL",
  COLLECTION_TILE = "COLLECTION_TILE",
}
